export default __webpack_public_path__ + "static/media/alert-circle.ce682ad9.svg";